import currency from 'currency.js'

const getGroupingLabel = item => item.team || item.estimator || '(none)'

export const toBarChartData = data =>
  data.reduce(
    (acc, item) => {
      const groupingLabel = getGroupingLabel(item)
      acc.totalBidCount = (acc.totalBidCount || 0) + item.bidCount
      acc.totalWonCount = (acc.totalWonCount || 0) + item.wonCount
      acc.totalBidValue = currency(acc.totalBidValue || 0).add(item.bidValue).value
      acc.totalWonValue = currency(acc.totalWonValue || 0).add(item.wonValue).value

      if (!acc.groups.includes(groupingLabel)) {
        acc.groups.push(groupingLabel)
      }

      const existingIdx = acc.barByEstimator.findIndex(e => e.groupLabel === groupingLabel)
      if (existingIdx >= 0) {
        acc.barByEstimator[existingIdx].bidValue = currency(
          acc.barByEstimator[existingIdx].bidValue
        ).add(item.bidValue).value
        acc.barByEstimator[existingIdx].wonValue = currency(
          acc.barByEstimator[existingIdx].wonValue
        ).add(item.wonValue).value
      } else {
        acc.barByEstimator.push({
          groupLabel: groupingLabel,
          bidValue: currency(item.bidValue).value,
          wonValue: currency(item.wonValue).value
        })
      }

      return acc
    },
    {
      totalBidCount: 0,
      totalWonCount: 0,
      totalBidValue: 0,
      totalWonValue: 0,
      groups: [],
      barByEstimator: []
    }
  )

export const toBarChartDataByWorkType = data => {
  const workTypes = [...new Set(data.map(d => d.workType || '(none)'))]
  const groups = [...new Set(data.map(getGroupingLabel))]

  const barByEstimator = groups.map(groupLabel => {
    const groupingData = data.filter(d => getGroupingLabel(d) === groupLabel)
    const row = { groupLabel }
    workTypes.forEach(wt => {
      const match = groupingData.find(d => (d.workType || '(none)') === wt)
      row[wt] = match ? currency(match.bidValue).value : 0
    })
    return row
  })

  const totals = data.reduce(
    (acc, item) => {
      acc.totalBidCount += item.bidCount
      acc.totalWonCount += item.wonCount
      acc.totalBidValue = currency(acc.totalBidValue).add(item.bidValue).value
      acc.totalWonValue = currency(acc.totalWonValue).add(item.wonValue).value
      return acc
    },
    { totalBidCount: 0, totalWonCount: 0, totalBidValue: 0, totalWonValue: 0 }
  )

  return { barByEstimator, keys: workTypes, groups, ...totals }
}

export const toTable = data =>
  data.map(item => ({
    groupLabel: getGroupingLabel(item),
    team: item.team,
    estimator: item.estimator,
    workType: item.workType || '(none)',
    bidCount: item.bidCount,
    wonCount: item.wonCount,
    bidValue: item.bidValue,
    wonValue: item.wonValue,
    winCountPercentage: item.winCountPercentage,
    winValuePercentage: item.winValuePercentage,
    workTypeWonShare: item.workTypeWonShare
  }))

export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName
  }))

export const toRoles = roles =>
  roles.map(role => ({
    value: role.name,
    label: role.value
  }))
